var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"example-view"},[_c('multi-children-vertical-menu',{attrs:{"menus":_vm.menus},on:{"click":_vm.onClickMenuItem}}),_c('div',{staticClass:"overflow-y-auto",staticStyle:{"width":"100%","height":"100vh","background-color":"#F9FCFF"}},[_c('router-view',{staticClass:"pb-10",staticStyle:{"width":"80%","margin":"0 auto"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }